import {useState} from 'react';
import ChatWidget from './Chat';
import {getAlphanumericString} from '../utils/string';

const MAX_CHATS = 10;

export const ChatSection = ({
  queryParamsLoaded,
  queryParams,
  lfToken,
  decodedToken,
}) => {
  const [chats, setChats] = useState([]);

  const addChat = () => {
    if (!decodedToken?.id) {
      console.log('No se puede agregar chat sin decodedToken.id');
      return;
    }

    const newSessionId = `${
      decodedToken?.id
    }_${new Date().getTime()}_${getAlphanumericString(8)}`;

    setChats(prev => [
      ...prev,
      {
        session_id: newSessionId,
        minimized: false,
      },
    ]);
  };

  const onCloseChat = session_id => {
    setChats(prev => prev.filter(chat => chat.session_id !== session_id));
  };

  const onToggleMinimizeChat = session_id => {
    setChats(prev =>
      prev.map(chat =>
        chat.session_id === session_id
          ? {
              ...chat,
              minimized: !chat.minimized,
            }
          : chat,
      ),
    );
  };

  const shouldShowChat = Boolean(
    queryParamsLoaded &&
    queryParams?.soyIframe !== 'yes' &&
    lfToken &&
    lfToken !== '' &&
    lfToken !== 'null' &&
    decodedToken?.id &&
    decodedToken?.rol === 'selector',
  );

  if (!shouldShowChat) {
    return null;
  }

  const maxChatsReached = chats.length >= MAX_CHATS;

  return (
    <div
      style={{
        position: 'absolute',
        top: 10,
        left: 280,
        zIndex: 2000,
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'flex-start',
      }}>
      {chats.map((chat, index) => (
        <ChatWidget
          key={chat.session_id}
          session_id={chat.session_id}
          window_title={`Chat ${index + 1}`}
          minimized={chat.minimized}
          onToggleMinimize={onToggleMinimizeChat}
          onClose={onCloseChat}
        />
      ))}

      <button
        onClick={addChat}
        style={{
          width: 30,
          height: 30,
          borderRadius: '50%',
          backgroundColor: maxChatsReached ? '#9b9b9bff' : '#ff8800ff',
          color: 'white',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          fontSize: 30,
          fontWeight: 'bold',
          cursor: maxChatsReached ? 'not-allowed' : 'pointer',
          marginLeft: 5,
          border: 'none',
        }}
        disabled={maxChatsReached}>
        +
      </button>
    </div>
  );
};
